import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcNotification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 2a1 1 0 0 1 .993.883L17 3l.001 2.013c4.933.14 6.715 1.397 8.05 5.314l.162.495c.029.09.068.22.114.376l1.206 4.18a73.47 73.47 0 0 0 1.407 4.28l.06.166V26h-7.063c-.342 2.586-2.069 4-4.937 4-2.868 0-4.595-1.414-4.937-4H4v-6.176l.06-.166a76.283 76.283 0 0 0 1.63-5.04c.016-.059.23-.814.468-1.646l.09-.315.136-.47.403-1.365C8.144 6.514 9.864 5.158 15 5.013V3a1 1 0 0 1 1-1Zm2.916 24.001h-5.832C13.349 27.398 14.257 28 16 28c1.743 0 2.651-.602 2.916-1.999Zm-2.61-19H15.7c-4.82.029-5.86.786-7.006 4.422l-.025.082c-.037.12-.086.285-.143.479L7.383 15.95a75.416 75.416 0 0 1-1.443 4.39l.059-.168V24h20v-3.83l-.201-.561a76.828 76.828 0 0 1-1.181-3.658l-.225-.766c-.003-.016-.873-3.084-1.086-3.762l-.14-.43C22.046 7.656 20.876 7 16 7Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcNotification;
